import type { TypeNavNode, TypeNavTrail } from '@/types/ui/types.ui.navigation';

export default function navigationFlatten(nodes: TypeNavNode[], parents: TypeNavNode[] = []): TypeNavTrail[] {
    return nodes.flatMap((node) => {
        const trail = [...parents, node];
        const own: TypeNavTrail = { node, trail };
        return node.children ? [own, ...navigationFlatten(node.children, trail)] : [own];
    });
}
